import React, { useState, useEffect } from 'react';
import '../style/backToTop/backToTop.css';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    setVisible(window.pageYOffset > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div
      id="return-to-top"
      className={visible ? 'show' : ''}
      onClick={scrollToTop}
      role="button"
      title="Back to top"
    >
      <i className="fa fa-angle-up" />
    </div>
  );
};

export default BackToTop;